class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contentss',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.cart__blocks .js-contents',
      },
    ];
  }
  enforceGiftItemRules(response) {
          const giftItems = response.items
            .map((item, index) => ({ ...item, index }))
            .filter(item => item.properties && item.properties._Gifted);
        
          if (giftItems.length === 0) return;
         console.log('giftItems'  , giftItems)
          const allQuantities = giftItems.map(item => item.quantity);
          const hasQuantityOne = allQuantities.includes(1);
        
          if (hasQuantityOne) {
            giftItems.forEach(item => {
              if (item.quantity !== 1) {
                updateQuantity(item.index, 0);
              }
            });
          } else {
            giftItems.forEach((item, i) => {
              if (i === 0) {
                updateQuantity(item.index, 1);
              } else {
                updateQuantity(item.index, 0);
              }
            });
          }
        }
  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
         this.enforceGiftItemRules(parsedState)
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    
    console.log('cart updated');
    var getCartTotalElement = document.querySelector('.cart-items-total');
    if(getCartTotalElement){
      var getCartTotal = getCartTotalElement.getAttribute('data-cart-total');
      console.log(getCartTotal);
    }
    var freeGiftProducts = document.querySelectorAll('.free-gift-product');
    if(freeGiftProducts){
      freeGiftProducts.forEach(freeGiftProduct => {
        var freeLimitValue = freeGiftProduct.getAttribute('data-free-limit');
        var freeItemTitle = freeGiftProduct.getAttribute('data-free-added');
        var freePercent = freeGiftProduct.getAttribute('data-free-percent');
        var freePercentage = (getCartTotal * 100) / freeLimitValue;
        if(freeLimitValue > getCartTotal){}
          var remainingToFree = freeLimitValue - getCartTotal;

        console.log(remainingToFree,'remainingToFree');
        if(freeLimitValue > getCartTotal){
          console.log('freeLimitValue > getCartTotal');
          if(remainingToFree > 0){
            let formattedRemainingToFree = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(remainingToFree);
            freeGiftProduct.querySelector('circle').setAttribute('style',"stroke-dasharray: 133.518; stroke-dashoffset:  calc(133.518px - (133.518px * "+freePercentage+") / 100);");
            freeGiftProduct.querySelector('.cart-add-form').classList.remove('hidden');
            freeGiftProduct.querySelector('.cart-change-form').classList.add('hidden');
            console.log(freeGiftProduct.querySelector('.redeem-btn'));
            freeGiftProduct.querySelector('.cart-add-form').querySelector('.redeem-btn').textContent = 'add ' +formattedRemainingToFree+ ' more';
            freeGiftProduct.querySelector('.cart-add-form').querySelector('.redeem-btn').setAttribute('disabled','true');
            
            console.log('remainingToFree',formattedRemainingToFree);
            freeGiftProduct.querySelector('.gwp-subtitle span').innerHTML = `You're only <span data-currency="{{ cart.currency.symbol }}" class="away-from">${formattedRemainingToFree}</span> away from this reward!`;
          }
          
        }
        else{
          console.log('freeLimitValue < getCartTotal')
        }
          if(remainingToFree > 0){
            var remainingTargetElements = freeGiftProduct.querySelectorAll('.away-from');
            if(remainingTargetElements){
              let formattedRemainingToFree = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(remainingToFree);
              remainingTargetElements.forEach(remainingTargetElement => {
                var remainingTargetElementCurrency = remainingTargetElement.getAttribute('data-currency');
                remainingTargetElement.innerHTML = remainingTargetElementCurrency + ' ' + remainingToFree;
                freeGiftProduct.querySelector('circle').setAttribute('style',"stroke-dasharray: 133.518; stroke-dashoffset:  calc(133.518px - (133.518px * "+freePercentage+") / 100);")
            
                freeGiftProduct.querySelector('.gwp-subtitle span').innerHTML = `You're only <span data-currency="{{ cart.currency.symbol }}" class="away-from">${formattedRemainingToFree}</span> away from this reward!`;
                
                freeGiftProduct.querySelector('.cart-add-form').classList.remove('hidden');
                freeGiftProduct.querySelector('.cart-change-form').classList.add('hidden');
                console.log('remainingToFree: ',remainingToFree,' getCartTotal: ',getCartTotal);
              })
            } 
          }else{
            var variantFound = false;
            function checkVariantInCart(dataIdValue) {
  return new Promise(function(resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "/cart.js", true);
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          var data = JSON.parse(xhr.responseText);
          if (data.items && data.items.length > 0) {
            var variantFound = false;
            for (var i = 0; i < data.items.length; i++) {
              if (data.items[i].variant_id == dataIdValue) {
                variantFound = true;
                break;
              }
            }
            resolve(variantFound);
          } else {
            resolve(false); // Cart is empty
          }
        } else {
          reject(xhr.statusText); // Error occurred
        }
      }
    };
    xhr.send();
  });
}

let dataIdValue = freeGiftProduct.querySelector('.redeem-btn').getAttribute('data-id');
checkVariantInCart(dataIdValue)
  .then(function(variantFound) {
    if (variantFound) {
      console.log("Variant", dataIdValue, " in the cart.");
       freeGiftProduct.querySelector('.gwp-subtitle span').innerHTML = `Your FREE <span class="capitalize">${freeItemTitle}</span> was added to your bag`;
            freeGiftProduct.querySelector('.cart-add-form').classList.add('hidden');
            freeGiftProduct.querySelector('.cart-change-form').classList.remove('hidden');
            freeGiftProduct.querySelector('.redeem-btn').textContent = 'remove';
            freeGiftProduct.querySelector('.redeem-btn').removeAttribute('disabled');
            freeGiftProduct.querySelector('circle').setAttribute('style',"stroke-dasharray: 133.518; stroke-dashoffset:  calc(133.518px - (133.518px * 100) / 100);");
    } else {
      console.log("Variant", dataIdValue, " not in the cart.");
      let btn_add_selector = '.form_'+dataIdValue+' .redeem-btn';
      freeGiftProduct.querySelector('.gwp-subtitle span').innerHTML = `Sweet! Your order qualifies for this reward — redeem now!`;
            freeGiftProduct.querySelector('.cart-add-form').classList.remove('hidden');
            freeGiftProduct.querySelector('.cart-change-form').classList.add('hidden');
            document.querySelector(btn_add_selector).textContent = 'get this free';
            document.querySelector(btn_add_selector).removeAttribute('disabled');
            document.querySelector(btn_add_selector).classList.remove('remove-redeem-btn');
            document.querySelector(btn_add_selector).classList.add('add-redeem-btn');
            freeGiftProduct.querySelector('circle').setAttribute('style',"stroke-dasharray: 133.518; stroke-dashoffset:  calc(133.518px - (133.518px * 100) / 100);");
    }
  })
  .catch(function(error) {
    console.error("Error occurred:", error);
  });


          }
        
        
      })
    }
  }
}

customElements.define('cart-items', CartItems);

var currentMessageLength = document.querySelector('.current-gm-length');
if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
            
          }, ON_CHANGE_DEBOUNCE_TIMER)),
          this.querySelector('textarea').addEventListener('input', debounce((event) => {
            var cartNoteMaxLength = this.querySelector('textarea').getAttribute('maxlength');
            
            if(currentMessageLength){
              currentMessageLength.innerHTML = this.querySelector('textarea').value.length;
              if(this.querySelector('textarea').value.length > 200){
                this.querySelector('textarea').style.borderColor = 'red';
                if(this.querySelector('.gift-input-info')){
                  this.querySelector('.gift-input-info').style.color = 'red';
                }
              }else{
                this.querySelector('textarea').style.borderColor = '#636363';
               if(this.querySelector('.gift-input-info')){
                 this.querySelector('.gift-input-info').style.color = '#636363';
               }
              }
            }
          }),
          document.addEventListener('DOMContentLoaded', () => {
            var cartNotes = document.querySelectorAll('.cart__note textarea');
            if(cartNotes){
              cartNotes.forEach(cartNoteText => {
                if(currentMessageLength){
                  currentMessageLength.innerHTML = cartNoteText.value.length
                }
                if(cartNoteText.value.length > 200){
                  cartNoteText.style.borderColor = 'red';
                  if(document.querySelector('.gift-input-info')){
                    document.querySelector('.gift-input-info').style.color = 'red';  
                  }
                  }else{
                    cartNoteText.style.borderColor = '#636363';
                   if(document.querySelector('.gift-input-info')){
                     document.querySelector('.gift-input-info').style.color = '#636363';  
                   }
                }
              })
            }
          })
        )
      }
    }
  );
}
